import React from 'react';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import { prettyNumber } from '../../../utils/helpers';
import { useImageAlt } from '../../../hooks/useImageAlt';

const ApartmentFilterCard = ({
  item,
  setModal,
  setApartment,
  imgDescription
}) => {
  const { t } = useTranslation();
  const totalPrice = prettyNumber(Math.round(item.area * item.priceFrom));
  const pricePerMeter = prettyNumber(item.priceFrom);
  const { currency } = item;
  const imgAlt = useImageAlt({
    rooms: item.rooms,
    area: item.area,
    description: imgDescription
  });

  const clickHandler = () => {
    setModal(true);
    setApartment(item);
  };

  return (
    <div
      className="ap-filter__flat"
      onClick={clickHandler}
      key={item.id}
      onKeyPress={clickHandler}
      role="button"
      tabIndex="0"
    >
      <div className="ap-filter__flat-top">
        <div className="ap-filter__flat-info">
          <div className="ap-filter__flat-area">
            <span className="ap-filter__flat-area__roominess">
              {t('rooms.rooms_count', {
                count: item.rooms,
                postProcess: 'interval'
              })}
            </span>
            <span className="ap-filter__flat-area__value">
              {t('area_metres', { area: item.area })}
            </span>
          </div>
          <div className="ap-filter__flat-price">
            <div className="ap-filter__flat-price__month">
              <Trans
                i18nKey="apartment_price"
                values={{
                  price: totalPrice,
                  currency
                }}
              >
                <span className="price-val">{{ totalPrice }}</span>
                <span className="price-cur">{{ currency }}</span>
              </Trans>
            </div>
            <div className="ap-filter__flat-price__per-meter">
              <Trans
                i18nKey="apartment_price_per_meter"
                values={{
                  price: pricePerMeter,
                  currency
                }}
              >
                <span className="price-val">{{ pricePerMeter }}</span>
                <span className="price-cur">{{ currency }}</span>
              </Trans>
            </div>
          </div>
          <div className="ap-filter__flat-bottom">
            {item.repair && (
              <span>
                {t('apartment_repair', {
                  name: item.repair?.name
                })}
              </span>
            )}
            {item.balconiesCount && (
              <span>
                {t('apartment_balcon_count', { count: item.balconiesCount })}
              </span>
            )}
            {item.bathroomsCount && (
              <span>
                {t('apartment_bathroom_count', { count: item.bathroomsCount })}
              </span>
            )}
          </div>
        </div>
        <div className="ap-filter__flat-photos">
          <img src={item.photos[0].f660x496} alt={imgAlt} />
        </div>
      </div>
    </div>
  );
};

ApartmentFilterCard.propTypes = {
  item: PropTypes.object,
  setModal: PropTypes.func,
  setApartment: PropTypes.func,
  imgDescription: PropTypes.string
};

export default ApartmentFilterCard;
